var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1119_7108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 44C41.0457 44 50 35.0457 50 24C50 12.9543 41.0457 4 30 4C18.9543 4 10 12.9543 10 24C10 35.0457 18.9543 44 30 44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8927 41.6887C39.7211 41.6887 47.6887 33.7211 47.6887 23.8927C47.6887 14.0642 39.7211 6.09668 29.8927 6.09668C20.0642 6.09668 12.0967 14.0642 12.0967 23.8927C12.0967 33.7211 20.0642 41.6887 29.8927 41.6887Z",
    stroke: "#C29F6B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7779 15.5841C28.7779 14.9262 29.2881 14.3999 29.8749 14.3999C30.5381 14.3999 31.0228 14.9262 31.0228 15.5841C31.0228 16.2157 30.5381 16.7157 29.8749 16.7157C29.2881 16.7157 28.7779 16.2157 28.7779 15.5841ZM30.5637 22.0315V32.1104C30.5637 32.7946 30.8698 33.0841 32.4004 33.0841V33.3999H27.4004V33.0841C28.931 33.0841 29.2371 32.7946 29.2371 32.1104V22.0315C29.2371 21.3473 28.931 21.0578 27.4004 21.0578V20.742H32.4004V21.0578C30.8698 21.0578 30.5637 21.3473 30.5637 22.0315Z",
    fill: "#C29F6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8 32.6842V33.8H27V32.6842H27.4C28.1687 32.6842 28.5253 32.606 28.6892 32.5094C28.7529 32.4718 28.7794 32.4358 28.7971 32.3944C28.8195 32.3419 28.8367 32.2568 28.8367 32.1105V22.0316C28.8367 21.8853 28.8195 21.8003 28.7971 21.7477C28.7794 21.7064 28.7529 21.6703 28.6892 21.6327C28.5253 21.5361 28.1687 21.4579 27.4 21.4579H27V20.3421H32.8V21.4579H32.4C31.6313 21.4579 31.2747 21.5361 31.1108 21.6327C31.0471 21.6703 31.0206 21.7064 31.0029 21.7477C30.9805 21.8003 30.9633 21.8853 30.9633 22.0316V32.1105C30.9633 32.2568 30.9805 32.3419 31.0029 32.3944C31.0206 32.4358 31.0471 32.4718 31.1108 32.5094C31.2747 32.606 31.6313 32.6842 32.4 32.6842H32.8ZM28.3776 15.5842C28.3776 14.7293 29.0437 14 29.8745 14C30.776 14 31.4224 14.7232 31.4224 15.5842C31.4224 16.437 30.7584 17.1158 29.8745 17.1158C29.0612 17.1158 28.3776 16.431 28.3776 15.5842ZM31.3131 21.1421C30.7108 21.2718 30.5637 21.5565 30.5637 22.0315V32.1104C30.5637 32.5854 30.7108 32.8703 31.3131 33C31.5784 33.0571 31.9324 33.0841 32.4004 33.0841V33.3999H27.4004V33.0841C27.8684 33.0841 28.2216 33.0571 28.4869 33C29.0892 32.8703 29.2371 32.5854 29.2371 32.1104V22.0315C29.2371 21.5565 29.0892 21.2718 28.4869 21.1421C28.2216 21.085 27.8684 21.0578 27.4004 21.0578V20.742H32.4004V21.0578C31.9324 21.0578 31.5784 21.085 31.3131 21.1421ZM29.8749 14.3999C29.2881 14.3999 28.7779 14.9262 28.7779 15.5841C28.7779 16.2157 29.2881 16.7157 29.8749 16.7157C30.5381 16.7157 31.0228 16.2157 31.0228 15.5841C31.0228 14.9262 30.5381 14.3999 29.8749 14.3999Z",
    fill: "#C29F6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1119_7108",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1119_7108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1119_7108",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoHover);
export default __webpack_public_path__ + "static/media/info_hover.b9db937a35b95a11e7716efe89a7b778.svg";
export { ForwardRef as ReactComponent };